import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { InventoryFormItem } from "./InventoryItemForm"
import type { EpicDependencies } from "../../rxjs/configureEpics"
import type { InventoryItem, InventoryItemLocation } from "../../data/types"

export const composeInventoryItem = (
    formData: InventoryFormItem,
    deps: EpicDependencies,
    categoryId: string
): InventoryItem => {
    // TODO handle inventoryLocations when update, omit for now
    // @ts-expect-error
    return {
        id: formData.inventoryItemId || deps.idgen.next(),
        categoryId: formData.categoryId || categoryId,
        isRestockableOnVoid: formData.isRestockableOnVoid,
        isRestockableOnRefund: formData.isRestockableOnRefund,
        lowThreshold: formData.lowThreshold,
    }
}

export const composeInventoryItemLocation = (
    inventoryItemLocationId: Maybe<string>,
    locationId: string,
    inventoryItemId: string,
    deps: EpicDependencies
): InventoryItemLocation => {
    return {
        id: inventoryItemLocationId || deps.idgen.next(),
        inventoryItemId: inventoryItemId,
        locationId: locationId,
        quantityTotal: 0,
    }
}
